import { Component, Output, EventEmitter } from '@angular/core';
import { MenuService } from './menu.service';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AccordionDirective, AccordionLinkDirective, AccordionAnchorDirective } from '../menu-accordion';
import { Router, RouterLink } from '@angular/router';

/* tslint:disable:max-line-length */
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    imports: [CommonModule, TranslatePipe, RouterLink, AccordionDirective, AccordionLinkDirective, AccordionAnchorDirective],
    providers: [MenuService]
})
export class MenuComponent {
  currentLang = 'en';
  menuItems = [];
  
  @Output() menuItemClicked = new EventEmitter<void>();
  
  constructor(
    public menuService: MenuService,
    public translate: TranslateService,
    private router: Router
  ) {
    this.menuItems = menuService.getAll();
  }
  
  /**
   * Check if the given route is active
   * This helps with applying the active class to menu items
   */
  isActive(route: string): boolean {
    // Check if current URL starts with this route
    return this.router.url === route || this.router.url.startsWith(route + '/');
  }
  
  /**
   * Handle menu item click events
   * Used to close the sidebar on mobile after navigation
   */
  onMenuItemClick(event: MouseEvent, isExternal: boolean = false): void {
    // For external links, we don't need to prevent the default behavior
    if (!isExternal) {
      // We only want to handle internal navigation events to close the sidebar
      this.menuItemClicked.emit();
    }
    
    // Check if we're on mobile
    const isMobile = window.innerWidth < 992;
    if (isMobile) {
      // Close the sidebar by emitting an event
      this.menuItemClicked.emit();
    }
  }
}
